module.exports = __webpack_public_path__ + "img/Spain.2b5c52fe.svg";